(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lr-imported-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new Map();
  function init() {
    const groups = new Map();
    document.querySelectorAll('.lr-customer-reviews').forEach(root => {
      const key = root.dataset.reviewGroup;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(root);
    });
    groups.forEach((roots, key) => {
      controllers.get(key)?.abort();
      const controller = new AbortController();
      controllers.set(key, controller);
      const on = (node, type, callback) => node?.addEventListener(type, callback, {signal:controller.signal});
      const first = roots.find(r => r.dataset.continuation !== 'true') || roots[0];
      const last = roots[roots.length - 1];
      const rows = roots.flatMap(r => [...r.querySelectorAll('[data-review-row]')]);
      const list = first.querySelector('[data-review-list]');
      const pager = last.querySelector('[data-review-pagination]');
      const status = last.querySelector('[data-page-status]');
      const designMode = Boolean(window.Shopify?.designMode);
      if (!designMode) {
        rows.forEach(row => list.append(row));
        roots.filter(r => r !== first).forEach(r => { if(r === last && pager)first.querySelector('.lr-cr-wrap').append(pager, status); r.hidden = true; });
      }
      const count = rows.length;
      const score = row => Number(row.dataset.score);
      const total = rows.reduce((sum, row) => sum + score(row), 0);
      const avg = first.querySelector('[data-average]');
      if (avg) avg.textContent = count ? (total / count).toFixed(2).replace('.', ',') : '0';
      document.querySelectorAll('[data-review-summary]').forEach(badge => {
        if (badge.dataset.reviewSummary !== key) return;
        badge.hidden = count === 0;
        badge.querySelector('[data-rating-average]').textContent = count ? (total / count).toFixed(2).replace('.', ',') : '0';
        badge.querySelector('[data-rating-count]').textContent = String(count);
        badge.querySelector('[data-rating-fill]').setAttribute('width', String(count ? Math.min(100, total / count * 20) : 0));
      });
      const countNode = first.querySelector('[data-count]');
      if (countNode) countNode.textContent = String(count);
      for (let rating = 1; rating <= 5; rating++) {
        const frequency = rows.filter(row => score(row) === rating).length;
        const label = first.querySelector(`[data-frequency="${rating}"]`);
        const bar = first.querySelector(`[data-bar="${rating}"]`);
        if (label)label.textContent=String(frequency);
        if (bar)bar.style.width=(count ? frequency / count * 100 : 0)+'%';
      }
      let page = 1, filter = 0;
      const sort = first.querySelector('[data-review-sort]');
      const reset = first.querySelector('[data-reset-filter]');
      function render(focus = false) {
        if (designMode) { rows.forEach(row => row.hidden = false); if(pager)pager.hidden=true; return; }
        let selected = rows.filter(row => !filter || score(row) === filter);
        if (sort?.value === 'pictures') selected = selected.filter(row => row.querySelector('.lr-cr-review-images img'));
        selected.sort((a,b) => {
          if (sort?.value === 'highest' && score(a) !== score(b)) return score(b)-score(a);
          if (sort?.value === 'lowest' && score(a) !== score(b)) return score(a)-score(b);
          return b.dataset.date.localeCompare(a.dataset.date) || Number(a.dataset.originalOrder)-Number(b.dataset.originalOrder);
        });
        const pages = Math.max(1, Math.ceil(selected.length / 5));
        page = Math.min(page,pages);
        rows.forEach(row => row.hidden=true);
        selected.forEach((row,index) => { list.append(row); row.hidden=index < (page-1)*5 || index >= page*5; });
        if (pager) {
          pager.replaceChildren(); pager.hidden=pages<=1;
          const button = (label, target, disabled=false, current=false) => {
            const b=document.createElement('button'); b.type='button'; b.textContent=label;
            b.disabled=disabled; b.setAttribute('aria-label',pager.dataset.pageLabel+' '+target);
            if(current)b.setAttribute('aria-current','page');
            on(b,'click',()=>{page=target;render(true)});pager.append(b);
          };
          button('«',1,page===1);button('‹',Math.max(1,page-1),page===1);
          const start=Math.max(1,Math.min(page-1,pages-2));
          for(let n=start;n<=Math.min(pages,start+2);n++)button(String(n),n,false,n===page);
          button('›',Math.min(pages,page+1),page===pages);button('»',pages,page===pages);
          if(status)status.textContent=pager.dataset.pageLabel+' '+page+' / '+pages;
        }
        if(reset)reset.hidden=!filter;
        first.querySelectorAll('[data-rating-filter]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.ratingFilter)===filter)));
        if(focus){first.querySelector('.lr-cr-heading')?.focus({preventScroll:true});list.scrollIntoView({block:'start'});}
      }
      on(sort,'change',()=>{page=1;render()});
      on(reset,'click',()=>{filter=0;page=1;render()});
      first.querySelectorAll('[data-rating-filter]').forEach(b=>on(b,'click',()=>{filter=filter===Number(b.dataset.ratingFilter)?0:Number(b.dataset.ratingFilter);page=1;render()}));
      const dialog=first.querySelector('[data-review-dialog]');
      on(first.querySelector('[data-write-review]'),'click',()=>dialog?.showModal());
      first.querySelectorAll('[data-close-dialog]').forEach(b=>on(b,'click',()=>b.closest('dialog').close()));
      const photoDialog=first.querySelector('[data-photo-dialog]');
      on(first.querySelector('[data-gallery-more]'),'click',()=>{
        const grid=photoDialog.querySelector('[data-all-photos]');grid.replaceChildren();
        rows.forEach(row=>row.querySelectorAll('.lr-cr-review-images a').forEach(link=>{
          const figure=document.createElement('figure'); const a=document.createElement('a');
          a.href=link.href;a.target='_blank';a.rel='noopener';const image=document.createElement('img');
          image.src=link.querySelector('img').src;image.alt=link.querySelector('img').alt;image.loading='lazy';a.append(image);
          const caption=document.createElement('figcaption');caption.textContent=row.querySelector('[data-review-name]').textContent;
          figure.append(a,caption);grid.append(figure);
        }));photoDialog.showModal();
      });
      if(designMode){if(sort)sort.disabled=true;first.querySelectorAll('[data-rating-filter]').forEach(b=>b.disabled=true);}
      render();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',()=>queueMicrotask(init));
})();

  } catch(e) { console.error(e); }
})();
})();
